/* eslint-disable no-use-before-define */
import { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import SidebarContent from 'src/pages/home/sidebar';
import { getKYCServicesTypes } from 'src/store/questionnaire/questionnaireService';

interface SidebarMenuProp {
  closeSidebar: () => void
}

const SidebarMenu: React.FC<SidebarMenuProp> = ({ closeSidebar }) => {
  const [headings, setHeadings] = useState<string[] | null>(null);
  const { questionnaires, status, tabIndex, action, client, visa_types, kyc_section_titles, docs_uploaded } = useAppSelector((state) => state.applications);
  const memHeadings = useMemo(() => headings, [headings])
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getKYCServicesTypes());
  }, []);

  useEffect(() => {
    if (questionnaires?.length > 0 && client != null && kyc_section_titles.length > 0) {
      const section_titles = [...kyc_section_titles];
      const immigration_type = visa_types.find(type => type.id === client.service_type);
      if (immigration_type) {
        const results = client.kyc_section_titles
          .map(id => section_titles.find(section => section.id === id))
          .filter(section => section !== undefined);
        const titles = results.map((res) => res?.title ?? '');
        if (titles) {
          setHeadings(titles)
        }
      }
    }
  }, [questionnaires, client, kyc_section_titles, visa_types]);

  return (
    <SidebarContent
      headings={memHeadings}
      required_docs={client?.required_documents ?? []}
      questionnaires={questionnaires}
      closeSidebar={closeSidebar}
      status={status}
      action={action}
      tabIndex={tabIndex}
      uploaded_docs={docs_uploaded}
    />
  );
}

export default SidebarMenu;
